import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';

import userLog from 'api/userLogService';

// ----------------------------------------------------------------------

type SmallActivityState = {
  secondLoading: boolean;
  secondList: [];
  secondSelected: readonly string[];
  secondClassId: string;
  secondStatus: string;
  searchValue: string;
};

const initialState: SmallActivityState = {
  secondLoading: false,
  secondList: [],
  secondSelected: [],
  secondClassId: '',
  secondStatus: 'all',
  searchValue: ''
};

const slice = createSlice({
  name: 'SmallActivity',
  initialState,
  reducers: {
    // START Second LOADING
    startSecondLoading(state) {
      state.secondLoading = true;
    },
    getSecondList(state, action) {
      state.secondLoading = false;
      state.secondList = action.payload;
    },
    clearSecondList(state) {
      state.secondList = [];
    },
    initSecond(state) {
      state.secondLoading = false;
      state.secondList = [];
      state.secondSelected = [];
      state.secondClassId = '';
      state.secondStatus = 'all';
      state.searchValue = '';
    },
    getSecondSelecteds(state, action) {
      state.secondSelected = action.payload;
    },
    getSecondClassId(state, action) {
      state.secondClassId = action.payload;
    },
    getSecondStatus(state, action) {
      state.secondStatus = action.payload;
    },
    getSearchValue(state, action) {
      state.searchValue = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
// Actions
export const {
  getSecondSelecteds,
  getSecondClassId,
  getSecondStatus,
  clearSecondList,
  getSearchValue,
  initSecond
} = slice.actions;

// 獲取list
export function getSecondListAction({ class_id, course_id, res_id, callback }: any) {
  return () => {
    dispatch(slice.actions.startSecondLoading());
    userLog
      .getUserReport({ class_id, course_id, res_id })
      .then((ret) => {
        dispatch(slice.actions.getSecondList(Array.isArray(ret) ? ret : []));
        if (callback) callback(ret);
      })
      .catch((_err) => {
        dispatch(slice.actions.getSecondList([]));
        if (callback) callback(_err);
      });
  };
}
